// import React, { useState, useEffect, useRef } from "react";
// import { useTranslation } from "react-i18next";
// import { FaUserCircle, FaEdit, FaUserEdit, FaPlus, FaTimes, FaSave, FaLightbulb, FaCheckCircle } from "react-icons/fa";
// import toast from "react-hot-toast";
// import "./professionalbio.css";

// const ProfessionalBio = ({ servitor }) => {
//   const { t } = useTranslation("servitor");
//   const [currentBio, setCurrentBio] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [bioInput, setBioInput] = useState("");
//   const textareaRef = useRef(null);

//   useEffect(() => {
//     const fetchedBio = servitor?.bio || `Experienced professional ${servitor?.service || "servitor"} with over ${servitor?.experience || "1"} year of dedicated service in ${servitor?.city || "Barishal"} area. I specialize in comprehensive solutions including installation, repair work, maintenance, and emergency services.

// My commitment to quality workmanship and customer satisfaction has earned me a 100% completion rate and excellent reviews from clients. I pride myself on being punctual, reliable, and providing cost-effective solutions for all needs.

// Available for both residential and commercial projects. I use modern tools and techniques to ensure long-lasting repairs and installations.`;
//     setCurrentBio(fetchedBio);
//   }, [servitor]);

//   const openModal = () => {
//     setBioInput(currentBio);
//     setIsModalOpen(true);
//     setTimeout(() => {
//       if (textareaRef.current) {
//         textareaRef.current.focus();
//       }
//     }, 100);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   const saveBio = () => {
//     const trimmedBio = bioInput.trim();
//     if (trimmedBio) {
//       setCurrentBio(trimmedBio);
//       closeModal();
//       toast.custom(
//         (tst) => (
//           <div
//             className={`custom-toast custom-toast-success ${tst.visible ? "slide-in" : "slide-out"}`}
//           >
//             <div className="toast-content">
//               <span className="toast-icon"><FaCheckCircle /></span>
//               <span className="toast-message">{t("servitorProfile.bioUpdatedSuccess") || "Bio updated successfully!"}</span>
//             </div>
//             <div className="toast-progress" style={{ animation: "progress 3s linear forwards" }} />
//           </div>
//         ),
//         { duration: 3000, position: "top-right" }
//       );
//     }
//   };

//   const handleInputChange = (e) => {
//     setBioInput(e.target.value);
//   };

//   const charCount = bioInput.length;

//   return (
//     <div className="servitorprofessionalbio-container">
//       <div className="servitorprofessionalbio-header">
//         <h2 className="servitorprofessionalbio-title">
//           <FaUserCircle className="servitorprofessionalbio-icon" />
//           {t("servitorProfile.professionalBio") || "Professional Bio"}
//         </h2>
//         <button onClick={openModal} className="servitorprofessionalbio-edit-btn">
//           <FaEdit className="servitorprofessionalbio-edit-icon" />
//           {t("servitorProfile.editBio") || "Edit Bio"}
//         </button>
//       </div>

//       {currentBio ? (
//         <div className="servitorprofessionalbio-content">
//           {currentBio.split('\n\n').map((paragraph, index) => (
//             <p key={index} className="servitorprofessionalbio-paragraph">{paragraph}</p>
//           ))}
//         </div>
//       ) : (
//         <div className="servitorprofessionalbio-empty">
//           <div className="servitorprofessionalbio-empty-content">
//             <FaUserEdit className="servitorprofessionalbio-empty-icon" />
//             <p className="servitorprofessionalbio-empty-title">{t("servitorProfile.noBio") || "No bio added yet"}</p>
//             <p className="servitorprofessionalbio-empty-subtitle">{t("servitorProfile.shareStory") || "Share your professional experience and skills with potential clients"}</p>
//           </div>
//           <button onClick={openModal} className="servitorprofessionalbio-add-btn">
//             <FaPlus className="servitorprofessionalbio-add-icon" />
//             {t("servitorProfile.addBio") || "Add Bio"}
//           </button>
//         </div>
//       )}

//       {isModalOpen && (
//         <div className="servitorprofessionalbio-modal-backdrop" onClick={closeModal}>
//           <div className="servitorprofessionalbio-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="servitorprofessionalbio-modal-header">
//               <h3 className="servitorprofessionalbio-modal-title">
//                 <FaEdit className="servitorprofessionalbio-modal-icon" />
//                 {t("servitorProfile.editProfessionalBio") || "Edit Professional Bio"}
//               </h3>
//               <button onClick={closeModal} className="servitorprofessionalbio-close-btn">
//                 <FaTimes />
//               </button>
//             </div>
//             <div className="servitorprofessionalbio-modal-content">
//               <label className="servitorprofessionalbio-label">
//                 {t("servitorProfile.bioDescription") || "Bio Description"}
//               </label>
//               <textarea
//                 ref={textareaRef}
//                 value={bioInput}
//                 onChange={handleInputChange}
//                 rows={8}
//                 maxLength={1000}
//                 className="servitorprofessionalbio-textarea"
//                 placeholder={t("servitorProfile.bioPlaceholder") || "Tell potential clients about your professional experience, skills, and what makes you unique. Share your expertise, work approach, and any specializations you have..."}
//               />
//               <div className="servitorprofessionalbio-char-count-wrapper">
//                 <p className="servitorprofessionalbio-share-text">
//                   {t("servitorProfile.shareProfessionalStory") || "Share your professional story and expertise"}
//                 </p>
//                 <span className={`servitorprofessionalbio-char-count ${charCount > 900 ? 'warning' : ''} ${charCount > 950 ? 'error' : ''}`}>
//                   {charCount}/1000
//                 </span>
//               </div>
//               <div className="servitorprofessionalbio-tips">
//                 <h4 className="servitorprofessionalbio-tips-title">
//                   <FaLightbulb className="servitorprofessionalbio-tips-icon" />
//                   {t("servitorProfile.bioWritingTips") || "Bio Writing Tips"}
//                 </h4>
//                 <ul className="servitorprofessionalbio-tips-list">
//                   <li>{t("servitorProfile.tipExperience") || "Highlight your years of experience and specializations"}</li>
//                   <li>{t("servitorProfile.tipServiceArea") || "Mention your service area and availability"}</li>
//                   <li>{t("servitorProfile.tipCertifications") || "Include any certifications or special skills"}</li>
//                   <li>{t("servitorProfile.tipProfessional") || "Keep it professional but personable"}</li>
//                 </ul>
//               </div>
//             </div>
//             <div className="servitorprofessionalbio-modal-actions">
//               <button onClick={closeModal} className="servitorprofessionalbio-cancel-btn">
//                 {t("servitorProfile.cancel") || "Cancel"}
//               </button>
//               <button onClick={saveBio} className="servitorprofessionalbio-save-btn" disabled={!bioInput.trim()}>
//                 <FaSave className="servitorprofessionalbio-save-icon" />
//                 {t("servitorProfile.saveBio") || "Save Bio"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ProfessionalBio;














import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  FaUser,
  FaEdit,
  FaPlus,
  FaSave,
  FaTimes,
  FaLightbulb,
  FaCheck,
  FaTimesCircle,
} from "react-icons/fa";
import toast from "react-hot-toast";
import "./professionalbio.css";
import { URL } from "../../../config";

const ProfessionalBio = ({ servitor }) => {
  const { t } = useTranslation("servitor");
  const [bio, setBio] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tempBio, setTempBio] = useState("");
  const [charCount, setCharCount] = useState(0);
  const maxChars = 1000;

  // same toast design as ServitorProfile
  const showCustomToast = (message, type, icon) => {
    toast.custom(
      (tt) => (
        <div
          className={`custom-toast custom-toast-${type} ${
            tt.visible ? "slide-in" : "slide-out"
          }`}
        >
          <div className="toast-content">
            <span className="toast-icon">{icon}</span>
            <span className="toast-message">{message}</span>
          </div>
          <div
            className="toast-progress"
            style={{ animation: "progress 3s linear forwards" }}
          />
        </div>
      ),
      { duration: 3000, position: "top-right" }
    );
  };

  // Initialize from parent
  useEffect(() => {
    if (servitor?.bio) setBio(servitor.bio);
  }, [servitor]);

  const openModal = () => {
    const b = bio || "";
    setTempBio(b);
    setCharCount(b.length);
    setIsModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setTempBio("");
    document.body.style.overflow = "auto";
  };

  const handleBioChange = (e) => {
    const text = e.target.value;
    if (text.length <= maxChars) {
      setTempBio(text);
      setCharCount(text.length);
    }
  };

  const saveBio = async () => {
    // simple guard
    const trimmed = tempBio.trim();
    if (!servitor?.Id) {
      showCustomToast(
        t("servitorProfile.toastNoServitor", { defaultValue: "Servitor not found." }),
        "error",
        <FaTimesCircle />
      );
      return;
    }
    if (!trimmed) {
      showCustomToast(
        t("servitorProfile.toastBioEmpty", { defaultValue: "Bio cannot be empty." }),
        "error",
        <FaTimesCircle />
      );
      return;
    }

    try {
      const token =
        localStorage.getItem("servitorToken") ||
        localStorage.getItem("token") ||
        "";

      await axios.patch(
        `${URL}/servitors/${servitor.Id}/bio`,
        { bio: trimmed },
        {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );

      setBio(trimmed); // optimistic update
      showCustomToast(
        t("servitorProfile.toastBioSaved", { defaultValue: "Bio saved successfully." }),
        "success",
        <FaCheck />
      );
      closeModal();
    } catch (e) {
      const msg =
        e?.response?.data?.error ||
        e?.response?.data?.message ||
        e?.message ||
        "Failed to save bio";
      showCustomToast(
        t("servitorProfile.toastBioFailed", { defaultValue: msg }),
        "error",
        <FaTimesCircle />
      );
      console.error("Error saving bio:", e);
    }
  };

  return (
    <>
      <div className="servitorprofessionalbio-wrapper">
        <div className="servitorprofessionalbio-card">
          <div className="servitorprofessionalbio-header">
            <h3 className="servitorprofessionalbio-title">
              <FaUser className="servitorprofessionalbio-title-icon" />
              {t("servitorProfile.professionalBio", { defaultValue: "Professional Bio" })}
            </h3>
            <button
              className="servitorprofessionalbio-edit-btn"
              onClick={openModal}
              aria-label={bio ? "Edit Bio" : "Add Bio"}
            >
              {bio ? <FaEdit /> : <FaPlus />}
              {bio
                ? t("servitorProfile.editBio", { defaultValue: "Edit Bio" })
                : t("servitorProfile.addBio", { defaultValue: "Add Bio" })}
            </button>
          </div>

          <div className="servitorprofessionalbio-content">
            {bio ? (
              <div className="servitorprofessionalbio-text">
                {bio.split("\n").map((paragraph, index) => (
                  <p key={index} className="servitorprofessionalbio-paragraph">
                    {paragraph}
                  </p>
                ))}
              </div>
            ) : (
              <div className="servitorprofessionalbio-empty">
                <div className="servitorprofessionalbio-empty-icon">
                  <FaUser />
                </div>
                <h4 className="servitorprofessionalbio-empty-title">
                  {t("servitorProfile.noBioTitle", { defaultValue: "No bio added yet" })}
                </h4>
                <p className="servitorprofessionalbio-empty-subtitle">
                  {t("servitorProfile.noBioSubtitle", {
                    defaultValue:
                      "Share your professional experience and skills with potential clients",
                  })}
                </p>
                <button className="servitorprofessionalbio-add-btn" onClick={openModal}>
                  <FaPlus />
                  {t("servitorProfile.addBio", { defaultValue: "Add Bio" })}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="servitorprofessionalbio-modal-overlay" onClick={closeModal}>
          <div
            className="servitorprofessionalbio-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="servitorprofessionalbio-modal-header">
              <h3 className="servitorprofessionalbio-modal-title">
                <FaEdit className="servitorprofessionalbio-modal-icon" />
                {bio
                  ? t("servitorProfile.editBio", {
                      defaultValue: "Edit Professional Bio",
                    })
                  : t("servitorProfile.addBio", {
                      defaultValue: "Add Professional Bio",
                    })}
              </h3>
              <button
                className="servitorprofessionalbio-modal-close"
                onClick={closeModal}
                aria-label="Close Modal"
              >
                <FaTimes />
              </button>
            </div>

            <div className="servitorprofessionalbio-modal-body">
              <div className="servitorprofessionalbio-form-group">
                <label className="servitorprofessionalbio-label">
                  {t("servitorProfile.bioDescription", { defaultValue: "Bio Description" })}
                </label>
                <textarea
                  className="servitorprofessionalbio-textarea"
                  value={tempBio}
                  onChange={handleBioChange}
                  placeholder={t("servitorProfile.bioPlaceholder", {
                    defaultValue:
                      "Tell potential clients about your professional experience, skills, and what makes you unique...",
                  })}
                  rows={8}
                  maxLength={1000}
                  autoFocus
                />
                <div className="servitorprofessionalbio-char-info">
                  <span className="servitorprofessionalbio-helper-text">
                    {t("servitorProfile.bioHelperText", {
                      defaultValue: "Share your professional story and expertise",
                    })}
                  </span>
                  <span
                    className={`servitorprofessionalbio-char-count ${
                      charCount > 900 ? "servitorprofessionalbio-char-warning" : ""
                    }`}
                  >
                    {charCount}/{maxChars}
                  </span>
                </div>
              </div>

              <div className="servitorprofessionalbio-tips">
                <h4 className="servitorprofessionalbio-tips-title">
                  <FaLightbulb className="servitorprofessionalbio-tips-icon" />
                  {t("servitorProfile.bioTipsTitle", { defaultValue: "Bio Writing Tips" })}
                </h4>
                <ul className="servitorprofessionalbio-tips-list">
                  <li>
                    {t("servitorProfile.bioTip1", {
                      defaultValue: "Highlight your years of experience and specializations",
                    })}
                  </li>
                  <li>
                    {t("servitorProfile.bioTip2", {
                      defaultValue: "Mention your service area and availability",
                    })}
                  </li>
                  <li>
                    {t("servitorProfile.bioTip3", {
                      defaultValue: "Include any certifications or special skills",
                    })}
                  </li>
                  <li>
                    {t("servitorProfile.bioTip4", {
                      defaultValue: "Keep it professional but personable",
                    })}
                  </li>
                </ul>
              </div>
            </div>

            <div className="servitorprofessionalbio-modal-footer">
              <button className="servitorprofessionalbio-cancel-btn" onClick={closeModal}>
                {t("common.cancel", { defaultValue: "Cancel" })}
              </button>
              <button
                className="servitorprofessionalbio-save-btn"
                onClick={saveBio}
                disabled={!tempBio.trim()}
              >
                <FaSave />
                {t("common.save", { defaultValue: "Save Bio" })}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfessionalBio;
